import axios from 'axios';

export const confirmPasswordHandler = (password: string) => {
  return (confirmPassword: string) => {
    return confirmPassword && confirmPassword !== password ? '\xa0Don`t match.' : undefined;
  };
};

export const emailHandler = async (value: string) => {
  const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/check-email/${value}`);
  if (response.data.success) {
    return undefined;
  }
  return `Email ${value} is already exist`;
};
